import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlatformService } from '@panamax/app-state';
import { ListTypes } from '@shared/constants/lists-constants';

@Component({
  selector: 'app-list-banner',
  templateUrl: './list-banner.component.html',
  styleUrls: [
    './list-banner.component.scss',
    '../../pages/lists-pages-common-styles.scss',
  ],
})
export class ListBannerComponent {
  @Input() listName: string;
  @Input() listItemCount: number;
  @Input() showEllipsis: boolean;
  @Output() ellipsisClickEventEmitter: EventEmitter<any> = new EventEmitter();
  @Output() printClickEventEmitter: EventEmitter<any> = new EventEmitter();
  @Output() downloadClickEventEmitter: EventEmitter<any> = new EventEmitter();

  readonly ListTypes = ListTypes;

  constructor(readonly platformService: PlatformService) {}

  handleEllipsisClickEvent(event: Event) {
    this.ellipsisClickEventEmitter.emit(event);
  }

  emitPrintClick(event: Event) {
    this.printClickEventEmitter.emit(event);
  }

  emitDownloadClick(event: Event) {
    this.downloadClickEventEmitter.emit(event);
  }
}
